@if (loadingLogin) {
  <metadv-loader></metadv-loader>
}
<div fxLayout="column" class="login-form">
  <img src="/assets/images/mxa_logo.svg" width="368" alt="METADVISOR" draggable="false" fxHide.lt-md  *hideBlank="false">
  <img src="/assets/images/metadvisor_logo_black.svg" alt="METADVISOR" draggable="false"  width="250"  fxHide.lt-md  *hideBlank="true">

  <span class="title1" fxFlexOffset="84px">Login</span>

  <span class="subtitle1" fxFlexOffset="20px">Accedi per monitorare le tue consulenze con Metadvisor, lo strumento all'avanguardia per un mondo in evoluzione.</span>

  <a [href]="ssoLink" fxFlexOffset="30px">
    <button mat-flat-button [disabled]="loading" color="primary" id="loginButton"  type="submit">ACCEDI CON SSO</button>
  </a>
  @if (errorString) {
    <span fxFlexOffset="4px" class="error-label">{{errorString}}</span>
  }
</div>
